import React, { useEffect, useState } from 'react'

const Test = () => {

    const [userName, setUserName] = useState("");

    const showUserDetails = () => {
        console.log("This is log from a function with single S", userName);
    }

      const showUserDetailss = () => {
        console.log("This is log from a function", userName);
    }

    useEffect(() => {
        showUserDetails();
        // console.log("This is log from USE EFFECt, yahan sb larkiya GGCW library wali hain")
    },[]);

    return (
        <>
            <h1>This is test screen</h1>
            <h2>This is user name {userName}</h2>

            <input type='text' value={userName} onChange={(e)=>setUserName(e.target.value)}></input>
            {/* <input type='text' value={userName} onChange={(e)=>console.log(e.target.value)}></input> */}
            <button type='button' onClick={showUserDetails} >Enter Here</button>
        </>
    )
}

export default Test